import useAppStore from "store/app"

const useErrorsCheck = (errorsCheck) => {
  const fields = useAppStore((state) => state.fields)
  const updateFieldErrorMessage = useAppStore((state) => state.updateFieldErrorMessage)

  const validate = () => {
    let valid = true

    errorsCheck.map((field) => {
      if (fields[field].error_message !== "") {
        valid = false
      }

      if (!fields[field]?.touched && fields[field]?.input_value?.length === 0) {
        valid = false
        updateFieldErrorMessage(field, "This field is required")
      }
    })

    return valid
  }

  return {
    validate,
  }
}

export default useErrorsCheck
